// extracted by mini-css-extract-plugin
module.exports = {"image":"FamilyTree-module--image--3r3Bv"};